import { useRef, useState } from "react";

export function useSlidingLabelButton() {
  const labelContainerRef = useRef<HTMLDivElement>(null);
  const [labelContainerWidth, setLabelContainerWidth] = useState(0);

  function onMouseEnter() {
    const labelContainer = labelContainerRef.current;

    if (!labelContainer) return;

    setLabelContainerWidth(labelContainer.scrollWidth);
  }

  function onMouseLeave() {
    setLabelContainerWidth(0);
  }

  return {
    labelContainerRef,
    onMouseEnter,
    onMouseLeave,
    labelContainerWidth,
  };
}
